<template>
  <div class="columns">
    <div
      class="column list-column-left
      is-three-fourths-desktop is-two-thirds-tablet"
    >
      <div class="box list-box">
        <list-view></list-view>
      </div>
    </div>
    <div class="column list-column-right is-one-fourth-desktop">
      <div class="box">
        <div>Search</div>
        <div class="columns">
          <div class="column"></div>
          <div class="column">U</div>
          <div class="column">B</div>
          <div class="column">i</div>
          <div class="column">u</div>
          <div class="column">R</div>
          <div class="column"></div>
        </div>
        <div>Keyboard Shortcuts</div>
      </div>
    </div>
  </div>
</template>

<script>
import ListView from "@/components/ListView.vue";

export default {
  name: "Lists",
  components: {
    "list-view": ListView
  }
};
</script>
